import(/* webpackMode: "eager" */ "/home/app/projects/chatsc_web/src/app/(login)/login/page.tsx");
